module.exports = __webpack_public_path__ + "static/media/1-app-easy.978d5eb1.png";